import { Link } from "react-router-dom";
import { ArrowUpRight, Info } from "lucide-react";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { CTASection } from "@/components/common/CTASection";
import { CASE_STUDIES } from "@/lib/content";

export default function Stories() {
  return (
    <>
      <PageHero
        kicker="Stories"
        title="How we help — brought to life."
        subtitle="Real-world scenarios that show how the HATCH Framework™ turns an India ambition into a working operation. As our first client wins land, this is where their stories will live."
      />

      <section className="border-b border-white/10 bg-[#131316] py-4" data-testid="stories-disclaimer">
        <div className="container-px flex items-center gap-2 text-xs text-zinc-400">
          <Info className="h-4 w-4 shrink-0 text-orange-400" />
          These are illustrative scenarios showing how we'd approach common situations — not claims of specific past clients.
        </div>
      </section>

      <section className="section-pad" data-testid="stories-list">
        <div className="container-px space-y-8">
          {CASE_STUDIES.map((s, i) => (
            <Reveal key={s.slug} i={i}>
              <Link
                to={`/stories/${s.slug}`}
                data-testid={`story-card-${s.slug}`}
                className={`group grid overflow-hidden rounded-[2rem] border border-white/10 bg-[#17171A] lg:grid-cols-2 ${i % 2 === 1 ? "lg:[&>div:first-child]:order-2" : ""}`}
              >
                <div className="relative h-60 lg:h-auto">
                  <img src={s.image} alt={s.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#17171A]/70 to-transparent lg:bg-gradient-to-r" />
                </div>
                <div className="flex flex-col justify-center p-8 sm:p-12">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-full border border-orange-500/20 bg-orange-500/5 px-3 py-1 font-mono text-[10px] uppercase tracking-wider text-orange-300">{s.sector}</span>
                    <span className="rounded-full border border-white/10 px-3 py-1 font-mono text-[10px] uppercase tracking-wider text-zinc-400">{s.tag}</span>
                  </div>
                  <h3 className="mt-5 font-head text-2xl font-bold leading-tight text-white group-hover:text-orange-400 sm:text-3xl">{s.title}</h3>
                  <p className="mt-4 text-zinc-400">{s.teaser}</p>
                  <div className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-orange-400">
                    Read the story
                    <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <CTASection />
    </>
  );
}
